import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import Modal from "react-modal";
import {
  DESCRICAO_MODULOS_INTERNO,
  MODULOS_DE_USO,
  INTERNO,
  MANUAL,
} from "../../utils/Constants";
import { TituloContainer } from "../Home/style";
import {
  CardBody,
  CardHeader,
  LogoCard,
  TituloCard,
  TextoContainer,
  TextoBody,
  Separador,
  TextoBotao,
} from "../Home/components/cardSistemas/style";
import {
  Descricao,
  Titulo,
  CardContainer,
  Card,
  BotaoCard,
  Pagina,
  AbasContainer,
  BotaoAba,
  ModalContainer,
  ModalBody,
  LinkManual,
  StyledModal,
  TituloModal,
  SubtituloModal,
  ConteudoModal,
  ModalHeader,
  CloseModal,
} from "./style";
import { getModulos } from "../../services/modulos";
import LogoAnalise from "../../assets/img/LogoAnalise.png";
import LogoFiscalizacaoOff from "../../assets/img/LogoFiscalizacaoOffline.png";
import LogoFiscalizacaoOn from "../../assets/img/LogoFiscalizacao.png";
import LogoGestaoDemandas from "../../assets/img/LogoGestaoDeDemandas.png";
import LogoSIG from "../../assets/img/LogoSIG.png";
import CloseModalIcon from "../../assets/icons/CloseModalIcon";

const Conteudo = () => {
  const [abaSistema] = useState(1);
  const [modalAberta, setModalAberta] = useState(false);
  const [moduloSelecionado, setModuloSelecionado] = useState(null);
  const [modulos, setModulos] = useState([]);
  const modulosFiltrados = [...modulos].sort((a, b) =>
    a.nome > b.nome ? 1 : -1
  );
  const setDadosModulos = async () => {
    const data = await getModulos();
    setModulos(data);
  };
  useEffect(() => {
    setDadosModulos();
  }, []);

  const abrirModal = (modulo) => {
    setModuloSelecionado(modulo);
    setModalAberta(true);
  };

  const fecharModal = () => {
    setModalAberta(false);
    setModuloSelecionado(null);
  };

  return (
    <>
      <Pagina>
        <TituloContainer>
          <Titulo>{MODULOS_DE_USO}</Titulo>
          <Titulo negrito>{INTERNO}</Titulo>
        </TituloContainer>
        <Descricao>{DESCRICAO_MODULOS_INTERNO}</Descricao>

        <CardContainer>
          {modulosFiltrados.map((modulo, index) => {
            return (
              <>
                <Card key={index}>
                  <CardHeader>
                    <LogoCard
                      src={
                        modulo.nome === "Análise SISLAM"
                          ? LogoAnalise
                          : modulo.nome === "Fiscalização Offline"
                          ? LogoFiscalizacaoOff
                          : modulo.nome === "Fiscalização Online"
                          ? LogoFiscalizacaoOn
                          : modulo.nome === "Gestão de Demandas"
                          ? LogoGestaoDemandas
                          : LogoSIG
                      }
                      alt="Logo"
                    />
                    <TituloContainer>
                      <TituloCard>{modulo.nome}</TituloCard>
                    </TituloContainer>
                  </CardHeader>
                  <Separador />
                  <CardBody>
                    {(modulo.manual != null && modulo.manual.length > 0) && (
                      <AbasContainer>
                        <BotaoAba active={abaSistema === 1}>Sobre o sistema</BotaoAba>
                        <BotaoAba onClick={() => abrirModal(modulo)}>Orientações</BotaoAba>
                      </AbasContainer>
                    )}
                    <TextoContainer>
                      <TextoBody>{modulo.descricao}</TextoBody>
                    </TextoContainer>
                    <BotaoCard
                      onClick={() =>
                        window.open(modulo.link, "_blank", "noreferrer")
                      }
                    >
                      <TextoBotao>Acessar</TextoBotao>
                    </BotaoCard>
                  </CardBody>
                </Card>
              </>
            );
          })}
        </CardContainer>

        {/* Modal para orientações */}
        {moduloSelecionado && (
          <Modal isOpen={modalAberta} style={StyledModal}>
            <ModalContainer>
              <ModalHeader>
                <TituloModal>{moduloSelecionado?.nome}</TituloModal>
                <CloseModal onClick={fecharModal}>
                  <CloseModalIcon />
                </CloseModal>
              </ModalHeader>
              <ModalBody>
                <SubtituloModal>{MANUAL}</SubtituloModal>
                <ConteudoModal
                  onClick={() =>
                    window.open(moduloSelecionado?.manual, "_blank", "noreferrer")
                  }
                >
                  <LinkManual>{moduloSelecionado?.nome} (Baixar Manual)</LinkManual>
                </ConteudoModal>
              </ModalBody>
            </ModalContainer>
          </Modal>
        )}
      </Pagina>
    </>
  );
};

export default Conteudo;
